module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hans/1/5-8180ffd35182866184291c1e37553376.jpg";